import React from "react";
import headerIcon from "../../assets/icons/header/logoVotenow@3x.png";
import "./styles.scss";

const Header = () => (
  <div className="header">
    <img src={headerIcon} className="logo" alt="header" />
  </div>
);

export default Header;
